
import { ReactComponent as AddIcon } from "./add.svg";
import { ReactComponent as SendIcon } from "./send-2.svg";
import { ReactComponent as SaveDraftIcon } from "./document_text.svg";
import { ReactComponent as SMSIcon } from "./sms-notification.svg";
import SearchIcon from '@mui/icons-material/Search';
import { ReactComponent as CSVIcon } from "./csvIcon.svg";
import { ReactComponent as ApproveCheckIcon } from "./tick-square.svg";
import { ReactComponent as RejectCheckIcon } from "./close-square.svg";
import { ReactComponent as ClockIcon } from "./clock.svg";
import { ReactComponent as MeetingIcon } from "./meetting.svg";
import { ReactComponent as ReturnIcon } from "./return.svg";
import { ReactComponent as DownloadIcon } from "./download2.svg";
import { ReactComponent as PDFIcon } from './pdf_icon.svg';
import { ReactComponent as PdfIcon } from "./icon_pdf.svg";



// BUTTON ICON
export const IconComponent = {
    AddIcon: AddIcon,
    SendIcon,
    SaveDraftIcon,
    SMSIcon,
    SearchIcon,
    CSVIcon,
    ApproveCheckIcon,
    RejectCheckIcon,
    ClockIcon,
    MeetingIcon,
    ReturnIcon,
    DownloadIcon,
    PDFIcon,
    PdfIcon
}